<template>
    <nav class="header-nav">
        <template v-for="(item, index) in navItems" :key="index">
            <UIDropDown
                v-if="item.subItems && item.subItems.length"
                :is-hover="true"
                :additional-top="26"
            >
                <template #trigger>
                    <a
                        class="header-nav__link"
                        :class="{ 'header-nav__link_active': isActive(item) }"
                    >
                        {{ item.label }}
                    </a>
                </template>

                <template #menu>
                    <ul class="header-nav__dropdown-menu">
                        <li
                            v-for="(subItem, subIndex) in item.subItems"
                            :key="subIndex"
                            class="header-nav__dropdown-item"
                        >
                            <router-link
                                :to="subItem.link"
                                class="header-nav__dropdown-link"
                            >
                                {{ subItem.label }}
                            </router-link>
                        </li>
                    </ul>
                </template>
            </UIDropDown>

            <router-link
                v-else
                :to="item.link"
                class="header-nav__link"
                :class="{ 'header-nav__link_active': isActive(item) }"
            >
                {{ item.label }}
            </router-link>
        </template>
    </nav>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useRoute } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { AuthKey } from '@/injection/keys.ts';

    import { getAdminNavItems, getDealerNavItems, NavItem, NavItems } from '@/types/navigation.type.ts';
    import { CurrentUser } from '@/types/user.type.ts';

    import UIDropDown from '@/components/ui/UIDropDown/UIDropDown.vue';

    const $Auth = injectStrict(AuthKey);

    const route = useRoute();

    const currentUser: CurrentUser = $Auth.getCurrentUser();

    const navItems = ref<NavItems>(currentUser.is_admin ? getAdminNavItems() : getDealerNavItems());

    const isActive = (navItem: NavItem): boolean => {
        const routes = route.matched.map((m) => m.path);

        return routes.includes(navItem.link);
    };
</script>

<style lang="scss" scoped>
    @use './HeaderNavigation.scss' as *;
</style>
